import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import "./locationlisting.scss";
import threedotvertical from "../../../assets/images/three-dots-vertical.svg";
import editicon from "../../../assets/images/edit-icon.svg";
import viewicon from "../../../assets/images/view-icon.svg";
import deactivateicon from "../../../assets/images/deactivate-icon.svg";
import deleteicon from "../../../assets/images/delete-icon.svg";
import { ReactSVG } from "react-svg";
import useLocations from "../../../Hooks/useLocations";
import Loading from "../../../components/LoadingPage/Loading";
import { setSelectedLocation } from "../../../redux/location/locationSlice";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCurrentUserId } from "../../../redux/auth/authSlice";
import { toggleClass } from "../../../utils/commonUtils";
import { DeleteConfModel } from "../../../components/DeleteConfModel/deleteConfModel";
import CommonHeaderWithImpoExpo from "../../../components/commonHeaderWithImpoExpo/commonHeaderWithImpoExpo";
import moment from "moment";
import { toast } from "react-toastify";
const LocationListing = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const currentUserId = useAppSelector(selectCurrentUserId);
  const { getLocationsAPI, getLocationsLoading } = useLocations();
  const { activeLocationAPI, setLocationStatusActiveLoading } = useLocations();
  const { deactiveLocationAPI, setLocationStatusDeActiveLoading } =
    useLocations();
  const { exportLocationAPI, exportLocationLoading } = useLocations();
  const { importLocationAPI, importLocationLoading } = useLocations();
  const { deleteLocationAPI, deleteLocationLoading } = useLocations();
  const [showModal, setShowModal] = useState(false);
  const [locationsList, setLocationsList] = useState<any>([]);
  const [currentLocation, setCurrentLocation] = useState<any>();
  const [sortColumn, setSortColumn] = useState("sortOrder");
  const [sortDirection, setSortDirection] = useState('asc'); // 'asc' or 'desc'
  const defaultFilter = { searchText: "", active: true, sortColumn: sortColumn, sortDirection: sortDirection };
  const [searchFieldVal, setSearchFieldVal] = useState(defaultFilter);
  const [showImportFileModal, setShowImportFileModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [importErrorDetails, setImportErrorDetails] = useState<any[]>([]);
  const deleteLocation = async () => {
    await deleteLocationAPI({
      id: currentLocation.id,
      updatedBy: currentUserId ?? "",
    });
    toggleModal();
    getLocations();
  };
  const toggleModal = () => {
    toggleClass();
    setShowModal(!showModal);
  };

  const getLocations = () => {
    getLocationsAPI(searchFieldVal)
      .then((res: any) => setLocationsList(res))
      .catch();
  };
  const editLocation = (location: any) => {
    dispatch(setSelectedLocation(location));
    navigate("/edit-location");
  };
  const navigateToView = (location: any) => {
    dispatch(setSelectedLocation(location));
    navigate("/view-location");
  };
  const updateStatus = async (location: any) => {
    if (location.isActive) {
      await deactiveLocationAPI({
        id: location.id,
        updatedBy: currentUserId ?? "",
      });
    } else {
      await activeLocationAPI({
        id: location.id,
        updatedBy: currentUserId ?? "",
      });
    }
    getLocations();
  };
  const handleSort = (columnName: string) => {
    // If the same column is clicked again, toggle the sort direction
    if (sortColumn === columnName) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
      setSearchFieldVal({ ...searchFieldVal, sortColumn: columnName, sortDirection: sortDirection === 'asc' ? 'desc' : 'asc' });
    }
    else {
      setSortColumn(columnName);
      setSortDirection('asc'); // Default to ascending when a new column is clicked
      setSearchFieldVal({ ...searchFieldVal, sortColumn: columnName, sortDirection: 'asc' });
    }
  };
  const handleExportLocationList = async () => {
    const response = await exportLocationAPI();
    const url = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${localStorage.getItem("profileClientId")?.toUpperCase() ?? ""}_Location_List_${moment().format('YYYYMMDD_HHmmss')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  };

  const toggleImportXlsxModal = () => {
    setSelectedFile(null);
    setImportErrorDetails([]);
    toggleClass();
    setShowImportFileModal(!showImportFileModal);
  };
  const handleImportLocationList = async (file: any) => {
    const formData = new FormData();
    formData.append("file", file || "");
    const response = await importLocationAPI({ 'file': formData, 'createdBy': currentUserId });
    if (response.error && response.error.data?.status !== 200 && response.error.data?.result?.isSuccess === false) {
      if (response.error.data?.status === 400) {
        toast.error(response.error.data?.result?.errorMessage);
      }
      toast.error("Error!. File imported unsuccessfully");
      const errorData = response.error.data?.result?.data?.filter((data: any) => data.isValid === false);
      setImportErrorDetails(errorData);
    } else {
      toast.success("Success!. File imported successfully");
      toggleImportXlsxModal();
      getLocations();
    }
  };

  useEffect(() => {
    getLocations();
  }, [searchFieldVal]);


  return (
    <div className="location-listing-wrapper">
      {getLocationsLoading ||
        setLocationStatusActiveLoading ||
        setLocationStatusDeActiveLoading ||
        exportLocationLoading ||
        importLocationLoading ||
        deleteLocationLoading ? (
        <Loading />
      ) : null}
      <CommonHeaderWithImpoExpo
        title="Location Master"
        buttonTitle="Add New"
        href="/add-location"
        disRecords={locationsList.length || 0}
        totalRecords={locationsList.length || 0}
        searchVal={searchFieldVal}
        setSearchVal={setSearchFieldVal}
        defaultFilter={defaultFilter}
        isAddPermitted={true}
        exportList={handleExportLocationList}
        importList={handleImportLocationList}
        showImportFileModal={showImportFileModal}
        setShowImportFileModal={setShowImportFileModal}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        toggleImportXlsxModal={toggleImportXlsxModal}
        importErrorDetails={{ data: importErrorDetails, module: "locations" }}
      />
      <div className="listing-table-wrapper">
        <Table responsive="md" hover={true}>
          <thead>
            <tr>
              <th onClick={() => handleSort('locationCode')}>Location Id {sortColumn === 'locationCode' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th onClick={() => handleSort('locationName')}>Location Name {sortColumn === 'locationName' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th>Mapped Location Name</th>
              <th onClick={() => handleSort('sortOrder')}>Sort Order {sortColumn === 'sortOrder' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {locationsList?.map((x: any) => (
              <tr
                key={x.id}
                onDoubleClick={() => {
                  navigateToView(x);
                }}
              >
                <td title={x.locationCode}>{x.locationCode}</td>
                <td title={x.locationName}>{x.locationName}</td>
                <td title={x.mappedLocationName}>{x.mappedLocationName}</td>
                <td title={x.sortOrder}>{x.sortOrder}</td>
                <td>
                  <span
                    className={`status-circle ${x.isActive ? "active" : "inactive"}`}
                  >
                    {x.isActive ? "Active" : "Inactive"}
                  </span>
                </td>
                <td>
                  <Dropdown>
                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                      <ReactSVG
                        className="svg-box"
                        wrapper="span"
                        src={threedotvertical}
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => navigateToView(x)}>
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={viewicon}
                        />
                        View
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          updateStatus(x);
                        }}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={deactivateicon}
                        />
                        {x.isActive ? "Deactivate" : "Activate"}
                      </Dropdown.Item>

                      <Dropdown.Item onClick={() => editLocation(x)}>
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={editicon}
                        />
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setCurrentLocation(x);
                          toggleModal();
                        }}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={deleteicon}
                        />
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <DeleteConfModel
        showModal={showModal}
        toggleModal={toggleModal}
        deleteAction={deleteLocation}
        recordName={currentLocation?.locationName || ""}
        modelName={`location`}
      />
    </div>
  );
};

export default LocationListing;
